// =============================================================
// i18n/index.ts — 언어 사전 통합 (digmol 스타일)
//   언어별 파일(locales/en.ts, ko.ts, ja.ts)을 묶어 I18N 으로 노출.
//   문구 수정은 각 locale 파일에서, 여기서는 조립만.
// =============================================================

import en from './locales/en';
import ko from './locales/ko';
import ja from './locales/ja';
import zh from './locales/zh';

export type Lang = 'en' | 'ko' | 'ja' | 'zh';

// 모든 언어 사전. 함수형 문구(예: sealCount(n))도 그대로 유지.
export const I18N: Record<string, any> = { en, ko, ja, zh };

// 지원 언어 목록 (UI 언어 스위처용) — EN → 中文 → 日本語 → 한국어
export const LANGS: Lang[] = ['en', 'zh', 'ja', 'ko'];

// 언어별 노출 거래소 (입금 안내/스캔 대상)
export const EXCHANGES_BY_LANG: Record<string, string[]> = {
  en: ['Binance', 'Coinbase'],
  ko: ['Bithumb', 'Binance', 'Coinbase'],
  ja: ['bitFlyer', 'Binance', 'Coinbase'],
  zh: ['Binance', 'Coinbase'],
};

export { en, ko, ja, zh };